// app/login/page.jsx (or wherever your login route is located)
// Run: npm install next

import React from 'react';

const LoginPage = () => {
  const togglePassword = () => {
    const passwordInput = document.getElementById('password');
    const toggleIcon = document.getElementById('password-toggle-icon');
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleIcon.textContent = 'visibility_off';
    } else {
      passwordInput.type = 'password';
      toggleIcon.textContent = 'visibility';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    const originalContent = btn.innerHTML;
    btn.innerHTML = '<span class="material-symbols-outlined animate-spin">progress_activity</span> Authenticating...';
    btn.disabled = true;

    setTimeout(() => {
      btn.innerHTML = originalContent;
      btn.disabled = false;
      alert('This is a UI demo. Authentication backend is not connected.');
    }, 1500);
  };

  return (
    <>
     

      <main className="flex w-full min-h-screen">
        {/* Left Side: Visual/Branding (Hidden on Mobile) */}
        <section className="hidden lg:flex lg:w-7/12 relative overflow-hidden">
          <div className="absolute inset-0 z-0 bg-primary overflow-hidden">
            <div
              className="w-full h-full animate-subtle-zoom bg-cover bg-center opacity-60"
              style={{
                backgroundImage:
                  "url('https://lh3.googleusercontent.com/aida-public/AB6AXuDrZCK05Xe4Z3_ySh8HUios2ncTgvmwvn13hq5Zrm5FX_MwKXjee3PNKlxL-YynHqAa6VUzuPf882hb5mHkYAp1A3XZSVSufN41GiX_dgvwT9Yoi8gTIA-BRbH6kozdaoFIk1lNveu6xkjYweWXk2pWbMA6epGcfO1OpucIzbcXfSD8yfhC9iVYqSA0blw5Erfp1fTb31Ho9vAkpVz_9ZaJLQVIXTFI3kbufm4QvmaIKDatdjNq24YFNwjNHWwoenH7yQ6xkBRQoDE')",
              }}
              data-alt="A professional locksmith focused on installing a high-tech smart lock system in a modern office building. The lighting is dramatic and cinematic, featuring deep navy shadows and sharp red highlights from the security system's LED indicators. The overall mood is authoritative, secure, and technologically advanced, reflecting the patriotic professional design system of The Locksmith USA."
            />
            <div className="absolute inset-0 login-gradient" />
          </div>
          <div className="relative z-10 flex flex-col justify-between p-16 w-full text-on-primary">
            <div className="flex items-center gap-4">
              <span className="material-symbols-outlined text-[32px]">shield_with_heart</span>
              <span className="font-headline-md text-headline-md tracking-tight">
                The Locksmith USA
              </span>
            </div>
            <div className="max-w-xl">
              <h1 className="font-headline-xl text-headline-xl mb-6 leading-tight">
                Securing the Nation, One Door at a Time.
              </h1>
              <p className="font-body-lg text-body-lg text-on-primary/80">
                Institutional-grade security solutions for property managers, government contractors,
                and enterprise leaders across the United States.
              </p>
            </div>
            <div className="flex gap-12 items-center">
              <div className="flex flex-col">
                <span className="font-headline-md text-headline-md">15k+</span>
                <span className="font-label-md text-label-md opacity-70">Verified Professionals</span>
              </div>
              <div className="flex flex-col">
                <span className="font-headline-md text-headline-md">24/7</span>
                <span className="font-label-md text-label-md opacity-70">Emergency Dispatch</span>
              </div>
              <div className="flex flex-col">
                <span className="font-headline-md text-headline-md">99.9%</span>
                <span className="font-label-md text-label-md opacity-70">Security Rating</span>
              </div>
            </div>
          </div>
        </section>

        {/* Right Side: Login Form */}
        <section className="w-full lg:w-5/12 bg-surface flex flex-col justify-center items-center px-6 lg:px-20 pb-4">
          <div className="w-full max-w-md">
            <div className="flex flex-col items-center mb-10 text-center">
              <img
                alt="The Locksmith USA Logo"
                className="h-20 w-20 mb-6 object-contain"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuBEt21-8YwMp0PByV_V4PQ-sinNO2OJPoicWVA1h8uBnJiWZDKsd70LJE6hABti3oiehRnTTY4A-S2FFnu4Gwx3wvIDxAXdVgigmZrB5Lf_m9DeFFwpmTORe6SYYCqDzRuJaMb9OkAdnvJzjAQCryC5KYlumaIj3px9KnqKY5sPRtxvDLtW_LodylbTL4gMioMqNOy2vRBFWse_73vmzalkwdwnEd3L1pJz_7MvhOUu-QinbgJ7numIkU0c5edFFSD7bFQiAc_AY2g"
              />
              <h2 className="font-headline-lg text-headline-lg text-primary mb-2">Welcome Back</h2>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Secure access to your professional dashboard.
              </p>
            </div>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Email Field */}
              <div>
                <label className="block font-label-md text-label-md text-on-surface mb-2" htmlFor="email">
                  Email Address
                </label>
                <div className="relative">
                  <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-outline">
                    mail
                  </span>
                  <input
                    className="w-full pl-12 pr-4 py-3 bg-surface-container-lowest border border-outline-variant rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all font-body-md text-body-md"
                    id="email"
                    name="email"
                    placeholder="hamza@gmail.com"
                    required
                    type="email"
                  />
                </div>
              </div>

              {/* Password Field */}
              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block font-label-md text-label-md text-on-surface" htmlFor="password">
                    Password
                  </label>
                </div>
                <div className="relative">
                  <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-outline">
                    lock
                  </span>
                  <input
                    className="w-full pl-12 pr-12 py-3 bg-surface-container-lowest border border-outline-variant rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all font-body-md text-body-md"
                    id="password"
                    name="password"
                    placeholder="Admin@123"
                    required
                    type="password"
                  />
                  <button
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-outline hover:text-on-surface"
                    onClick={togglePassword}
                    type="button"
                  >
                    <span className="material-symbols-outlined" id="password-toggle-icon">
                      visibility
                    </span>
                  </button>
                </div>
              </div>

             

              {/* Submit Button */}
              <button
                className="w-full bg-primary text-on-primary font-headline-md text-headline-sm py-4 rounded-lg hover:bg-primary-container active:scale-[0.98] transition-all flex items-center justify-center gap-3 shadow-md"
                type="submit"
              >
                Sign In
              </button>
            </form>

            {/* Footer Links */}
            <div className="mt-12 text-center border-t border-outline-variant pt-8">
              <p className="font-body-md text-body-md text-on-surface-variant mb-4">
                New to The Locksmith USA network?
              </p>
              <a
                className="inline-flex items-center gap-2 font-label-md text-label-md text-primary font-bold hover:gap-3 transition-all"
                href="#"
              >
                Request Professional Access
                <span className="material-symbols-outlined text-[18px]">arrow_forward</span>
              </a>
            </div>

         
          </div>
             {/* Security Badge */}
            <div className="w-100 mt-12 flex items-center justify-center gap-4 opacity-40">
              <div className="flex items-center gap-1 font-label-md text-label-md">
                <span className="material-symbols-outlined text-[16px]">verified_user</span>
                256-bit SSL Secure
              </div>
              <div className="h-4 w-[1px] bg-outline-variant"></div>
              <div className="flex items-center gap-1 font-label-md text-label-md">
                <span className="material-symbols-outlined text-[16px]">policy</span>
                Federal Compliance
              </div>
            </div>
        </section>

        <style jsx global>{`
          body {
            font-family: 'Hanken Grotesk', sans-serif;
          }
          .material-symbols-outlined {
            font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
            display: inline-block;
            vertical-align: middle;
          }
          .login-gradient {
            background: linear-gradient(135deg, rgba(0, 11, 40, 0.92) 0%, rgba(187, 0, 20, 0.1) 100%);
          }
          .animate-subtle-zoom {
            animation: zoom 20s infinite alternate;
          }
          @keyframes zoom {
            from {
              transform: scale(1);
            }
            to {
              transform: scale(1.1);
            }
          }
        `}</style>
      </main>
    </>
  );
};

export default LoginPage;